import { createAction } from 'redux-actions';
import { createRequestActions } from '../utils';
import * as controlCenterTypes from './controlCenterTypes';

export const startHangfire = createRequestActions(controlCenterTypes.START_HANGFIRE);
export const stopHangfire = createRequestActions(controlCenterTypes.STOP_HANGFIRE);
export const allowLogin = createRequestActions(controlCenterTypes.ALLOW_LOGIN);
export const prohibitLogin = createRequestActions(controlCenterTypes.PROHIBIT_LOGIN);
